import { getHpRegistrationInfo, saveHpRegistrationInfo } from "../api/registrationInfo";
import { getApplicationSettings, getInternationalCountries, getInternationalCountriesWithStates, getInternationalStates, getInternationalPreferredCountries } from "../api/applicationSettings";
import { removeDefaultSessions } from "../api/registration";
import * as membershipActions from "../actions/membershipActions";
import * as registrationActions from "../actions/registrationActions";
import * as accountActions from "../actions/accountActions";
import { getConferenceFees } from "../api/conferenceFee";
import { getMembership } from "../api/membership";
import { connect } from "react-redux";
import Page from "./Page";
import Box from "./Box";
import PropTypes from "prop-types";
import React, { PureComponent } from "react";
import { withRouter } from "react-router-dom";
import LoadingButton from "./LoadingButton";
import LoadingContent from "./LoadingContent";
import * as config from "../config";
import * as util from "../lib/util";
import { toast } from "react-toastify";
import "postal-codes-js";
import PhoneInput from "react-phone-input-2";
import "react-phone-input-2/lib/style.css";
import libphonenumber from "google-libphonenumber";

const validationStrings = {
    phoneMaskPattern: "(999) 999-9999",
    error: "error",
    required: "This field is required",
};

const healthPolicyInfo = {
    hillDayDate: "February 9, 2027",
    conferenceInfo: "conferenceInfo value",
    nextStepsHeader: "nextStepHeader value",
    nextStepsText: "nextStepsText value",
};

const strings = {
    phoneMaskPattern: "(999) 999-9999",
    error: "error",
    required: "This field is required",
    conferenceTermsOfService: "https://www.aanp.org/aanp-conference-terms-of-service-and-release-of-liability",
    aanpTermsOfUse: "https://www.aanp.org/aanp-terms-of-use",
    aanpPrivacyPolicy: "https://www.aanp.org/aanp-privacy-policy",
};

const input = {
    npi: "npi",
    isFirstConference: "isFirstConference",
    willHillDay: "willHillDay",
    travelPermitsHillDay: "travelPermitsHillDay",
    hillDayDepartureTime: "hillDayDepartureTime",
    country: "country",
    county: "county",
    street1: "street1",
    city: "city",
    zip: "zip",
    state: "state",
    addressType: "addressType",
    cellPhone: "cellPhone",    
    ackCovidSafety: "ackCovidSafety",
    emergencyContactFirstName: "emergencyContactFirstName",
    emergencyContactLastName: "emergencyContactLastName",
    emergencyContactPhoneNumber: "emergencyContactPhoneNumber",
    emergencyContactEmail: "emergencyContactEmail",
    noPhoneConsent: "noPhoneConsent",
};

class HealthPolicyQuestions extends PureComponent {
    static propTypes = {
        me: PropTypes.object.isRequired,
        storeRegistrationMembershipType: PropTypes.func.isRequired,
        storeRegistrationMethod: PropTypes.func.isRequired,
        registrationMembershipType: PropTypes.string,
        history: PropTypes.object.isRequired,
        getMe: PropTypes.func.isRequired,
    };

    constructor(props) {
        super(props);

        this.state = {
            registrationInfo: {
                //states: [],
                memberType: "",
                registeringAs: "",
                npi: "",
                cellPhone: ""                             
            },
            internationalCountriesWithStates: [],
            internationalCountries: [{}],
            internationalPreferredCountries: [{}],
            internationalStates: [{}],
            internationalCountryCodes: [],
            isLoadingQuickCheckout: false,
            isLoadingCheckout: false,
            conferenceFees: {
                totalWorkshopFees: 0,
                eventFee: 0,
                totalDue: 0,
                staffCredits: [],
                eventDiscount: {},
            },
            cellPhoneStorage: "",            
            ackCovidSafety: false,
            validation: {},
            noPhoneConsent: false,
        };   
        this.ref_contactCountry = React.createRef();
        this.ref_contactPostalCode = React.createRef();   
        this.ref_emergencyContactPhoneNumber = React.createRef();
    }

    componentDidMount = () => {
        if (this.props.me.event.conferenceType !== "HealthPolicy") {
            this.props.history.push("/");
        } else {
        }
        this._getRegistrationInfo();
        this._getConferenceFees();
        this._getApplicationSettings();
        this._getInternationalCountries(); 
        this._getInternationalPreferredCountries();
    };

    _getApplicationSettings = () => { 

        console.log("_getApplicationSettings");
    
        this.setState({ loadingPrerequisites: true });
        
        getApplicationSettings().then((response) => {        
          this.setState({ applicationSettings: JSON.parse(response), loadingPrerequisites: false });
        })    
    }

    _getInternationalStates = (countryName) =>
    {   
        console.log("_getInternationalStates");

        getInternationalStates(countryName).then((response) => {
        this.setState({ internationalStates: response });      
        })
    }

  _getInternationalCountries = () => { 
    console.log("_getInternationalCountries");

    this.setState({ loadingPrerequisites: true });

    getInternationalCountries().then((response) => {  
      this.setState({ internationalCountryCodes: response.map(({ iso2 }) => iso2) });
      this.setState({ internationalCountries: response, loadingPrerequisites: false });
    })
  }

  _getInternationalPreferredCountries = () => {

    console.log("_getInternationalPreferredCountries");

    this.setState({ loadingPrerequisites: true });

    getInternationalPreferredCountries().then((response) => {            
      this.setState({ internationalPreferredCountries: response.map(({ iso2 }) => iso2) });
      this.setState({ internationalCountries: response, loadingPrerequisites: false });
    })
  }

    _getRegistrationInfo = () => {
        this.setState({ loading: true });

        getHpRegistrationInfo().then(response => {

            const states = ["United States", "Canada", "Australia"];
            this.setState({ internationalCountriesWithStates: states });

            if(response.preferredMailingAddress === "Business Address") {
                response.preferredMailingAddress = "Work Address";
            }
    
            if (response.preferredMailingAddress === "" || (response.preferredMailingAddress !== "Home Address" || response.preferredMailingAddress !== "Work Address") === false) {
            response.preferredMailingAddress = "Home Address";
            response.addressType = "Home Address";
            response.street1 = "";
            response.street2 = "";
            response.city = "";
            response.zip = "";
            response.county = "";
            response.country = "United States";
            }

            if(response.country === null || response.country === "")
            {
              console.log("Address country is NULL (likely non-member), setting country to United States");
              this.setState({ showInternationalRegionTerritory: false });
              this.setState({ showState: true});
              response.country = "United States";
            }

            if(this.state.internationalCountriesWithStates.length === 0) {
                console.log("this.state.internationalCountriesWithStates has not been initialized yet!");
              }
        
              if(this.state.internationalCountriesWithStates.includes(response.country))
              {
                console.log("set state to show state, not territory");
                this.setState({ showInternationalRegionTerritory: false });
                this.setState({ showState: true});
              }
              else
              {
                console.log("set state to show territory, not state");
                this.setState({ showInternationalRegionTerritory: true });
                this.setState({ showState: false});
              }
        
            this._getInternationalStates(response.country);

            const target = {
                name: "country",
                value: response.country,
              };

            const event = {        
            target,
            }
    
            this._handleChange(event)

            response.businessPhone = util.maskPhoneNumber(
                validationStrings.phoneMaskPattern,
                response.businessPhone
            );
            response.homePhone = util.maskPhoneNumber(
                validationStrings.phoneMaskPattern,
                response.homePhone
            );
            if(response.cellPhone.length > 15){
                response.cellPhone = response.cellPhone.substring(3, response.cellPhone.length);
                response.cellPhone = util.maskPhoneNumber(
                    validationStrings.phoneMaskPattern,
                    response.cellPhone
                );
            };
            
            this.setState({
            cellPhoneStorage: response.cellPhone,
            registrationInfo: response,
            });

            if ("isFirstConference" in response) {
                if (response.isFirstConference !== null) {
                    response.isFirstConference = response.isFirstConference ? "true" : "false";
                }
            } else {
                response.isFirstConference = null;
            }

            if ("willHillDay" in response) {
                if (response.willHillDay !== null) {
                    response.willHillDay = response.willHillDay ? "true" : "false";
                }
            } else {
                response.willHillDay = null;
            }

            if ("travelPermitsHillDay" in response) {                
                if (response.travelPermitsHillDay !== null) {                    
                    response.travelPermitsHillDay = response.travelPermitsHillDay ? "true" : "false";
                }

                if (response.willHillDay === "false" || response.willHillDay === null) {
                    response.travelPermitsHillDay = null;
                    response.hillDayDepartureTime = "";
                }
            } else {
                response.travelPermitsHillDay = null;
            }

            this.setState({ cellPhoneStorage: response.cellPhone, registrationInfo: response, });
        });
    };

    _onPhoneNumberChange = (value, country, event, formattedValue) => {  
        // target will be null when changing country via click
        try {      
            let { registrationInfo } = this.state;
            let controlName = event.target.name;
            console.log("_onPhoneNumberChange: " + controlName + ", formattedValue: " + formattedValue); 
            registrationInfo[controlName] = formattedValue;
        } catch (error) {
          // intentionally ignored. event.target is likely NULL     
        }
    }

    _handleChange = e => {        

        const name = e.target.name;
        let value = e.target.value;
        const target = e.target;

        let { registrationInfo } = this.state;

        const validation = { ...this.state.validation };

        if (typeof e.target.checked !== "undefined" &&
            e.target.type === "checkbox"
        ) {
            value = target.checked;
        }

        if(name === "country") {
                registrationInfo.country = target.value;     
        
            if(this.state.internationalCountriesWithStates.includes(target.value)) {     
                
                this.setState({ showInternationalRegionTerritory: false});
                this.setState({ showState: true});
        
                this._getInternationalStates(target.value);
        
            } else {
        
                this.setState({ showInternationalRegionTerritory: true});
                this.setState({ showState: false});        
            }      
        }
        
        if (name.includes("Phone") && typeof value === "string") {
            value = util.maskPhoneNumber(validationStrings.phoneMaskPattern, value);
        }

        if (name === "ackCovidSafety") {
            this.setState({
                ackCovidSafety: e.target.checked,
            },                
            );             
        }

        if (name === "noPhoneConsent") {
            this.setState({
                noPhoneConsent: e.target.checked,
            },                
            );             
        }

        delete validation[name];

        if (name === "willHillDay" && (value === "false" || value === null)) {
            registrationInfo.travelPermitsHillDay = "";
            registrationInfo.hillDayDepartureTime = "";
            registrationInfo.cellPhone = "";
            registrationInfo.noPhoneConsent = "";
        }
        if (name === "willHillDay" && value === "true") {
            registrationInfo.cellPhone = this.state.cellPhoneStorage;
            registrationInfo.noPhoneConsent = this.state.noPhoneConsent;
        }

        if (name === "travelPermitsHillDay") {
            registrationInfo.hillDayDepartureTime = "";
        }

        if (name === "hillDayDepartureTime") {
            if(value === "") {
                registrationInfo.travelPermitsHillDay = null;
            }
            else {
                registrationInfo.travelPermitsHillDay = "true";
            }            
        }

        registrationInfo[name] = value;

        this.setState(prevState => ({
            ...prevState,
            validation,
            registrationInfo: {
                ...prevState.registrationInfo,
            },
        }));       
    };

    _getConferenceFees = () => {
        getConferenceFees(
            this.props.registrationMembershipType,
            this.props.joinRenewMembershipType,
            localStorage.getItem(config.storageKeys.promoCode)
        )
            .then(response => {
                this.setState({ conferenceFees: response, loading: false, });
            })
            .catch(error => { });
    };

    _saveRegistrationInfo = e => {
        if (e) {
            e.preventDefault();
        }

        if (this._validForm()) {
            const nextPage = e.target.value;

            let { registrationInfo } = this.state;

            if (nextPage === "checkout") {
                this.setState({
                    isLoadingQuickCheckout: true,
                });
            } else {
                this.setState({
                    isLoadingCheckout: true,
                });
            }

            saveHpRegistrationInfo(registrationInfo).then(response => {

                this.props.storeRegistrationMethod("");

                localStorage.setItem(config.storageKeys.isNp, registrationInfo.isNp);

                const hpStorageItems = {
                    isFirstConference: registrationInfo.isFirstConference,
                    willHillDay: registrationInfo.willHillDay,
                    travelPermitsHillDay: registrationInfo.travelPermitsHillDay,
                    hillDayDepartureTime: registrationInfo.hillDayDepartureTime,
                    cellPhone: registrationInfo.cellPhone,
                    npi: registrationInfo.npi,
                    noPhoneConsent: registrationInfo.noPhoneConsent,                    
                };

                localStorage.setItem(
                    config.storageKeys.hpRegistrationInfo,
                    JSON.stringify(hpStorageItems)
                );

                this.props.getMe().then(store => {
                    const { me } = store;
                    const membershipType = this.props.me.availableMembershipTypes.find(m => m.useForJoinCampaign === true);
                    if (
                        registrationInfo.registeringAs === "Associate Member" &&
                        me.person.memberType === "Associate Member" &&
                        me.person.isMember
                    ) {
                        this.props.storeRegistrationMembershipType(
                            registrationInfo.registeringAs
                        );
                    } else if (membershipType) {
                        this.props.storeRegistrationMembershipType(
                            membershipType.membershipTypeName
                        );
                        if (registrationInfo.registeringAs === "Associate Member") {
                            registrationInfo.registeringAs =
                                membershipType.membershipTypeName;
                        }
                    } else {
                        this.props.storeRegistrationMembershipType(
                            registrationInfo.registeringAs
                        );
                    }

                    if (nextPage === "checkout") {
                        this.props.storeRegistrationMethod("quick");
                        this.props.history.push("/checkout");
                    } else {
                        if (!me.isRegistered) {
                            removeDefaultSessions().then(response => {
                                if (
                                    me.membershipStatus !== 1 &&
                                    e.membershipStatus !== 2 &&
                                    me.availableMembershipTypes.filter(m => !m.disabledForUser).length > 0 &&
                                    registrationInfo.registeringAs
                                ) {
                                    getMembership(
                                        registrationInfo.registeringAs,
                                        localStorage.getItem(config.storageKeys.promoCode)
                                    ).then(response => {
                                        if (response.savings <= response.savingsLimit) {
                                            this.props.history.push("/" + nextPage);
                                        } else {
                                            this.props.history.push("/membership");
                                        }
                                    });
                                } else {
                                    this.props.history.push("/" + nextPage);
                                }
                            });
                        } else {
                            this.props.history.push("/" + nextPage);
                        }
                    }
                });
            });
        } else { 
            toast.error("Please review and complete the registration information.", {autoClose: 10000});           
            // if(!this.state.ackCovidSafety)
            // {
            //     toast.error("Please complete Safety Acknowledgment section.", {autoClose: 10000});
            // } 
            // else {                
            //     toast.error("Please review and complete the registration information.", {autoClose: 10000});
            // }
        }
    };

    _isValidPhone = (phoneNumber, iso2) => {
        console.log("_isValidPhone. phoneNumber: " + phoneNumber + " iso2: " + iso2);
        const phoneUtil = libphonenumber.PhoneNumberUtil.getInstance();
        try {
          let numberProto = phoneUtil.parse(phoneNumber, iso2);
          return phoneUtil.isValidNumber(numberProto);
        } catch (e) {
          console.log("Error in _isValidPhone: " + e.toString());
        }
      };
    

    _isValidEmail(email) {
        return /\S+@\S+\.\S+/.test(email);
    };

    _isValidPostalCode(iso2, value) {
        console.log("_isValidPostalCode iso2: " + iso2 + " value: " + value);
        const postalCodes = require('postal-codes-js');
        console.log(postalCodes.validate(iso2, value));
        return postalCodes.validate(iso2, value);
    }

    _validForm = () => {

        const validation = {};         
 
        // if(!this.state.ackCovidSafety){ 
        //     validation[this.state.ackCovidSafety] = {
        //         state: validationStrings.error,
        //         helpBlock: validationStrings.required,
        //     };
        // }
        
        let { registrationInfo } = this.state;

        Object.keys(registrationInfo).forEach(stateKey => {             

            if (input[stateKey]) {     
                
                if(stateKey === input.isFirstConference) {
                    if(registrationInfo.isFirstConference === null || registrationInfo.isFirstConference === "") {
                        validation[stateKey] = {
                            state: validationStrings.error,
                            helpBlock: validationStrings.required,
                        };
                    }
                }

                if(stateKey === input.willHillDay) {
                    if(registrationInfo.willHillDay === null || registrationInfo.willHillDay === "") {
                        validation[stateKey] = {
                            state: validationStrings.error,
                            helpBlock: validationStrings.required,
                        };
                    }
                }

                if(stateKey === input.cellPhone && registrationInfo[stateKey].length < 14 && !this._isValidPhone(registrationInfo[stateKey])){
                    if (registrationInfo.willHillDay === "true") {
                        validation[stateKey] = {
                            state: validationStrings.error,
                            helpBlock: validationStrings.required,
                        };
                    }
                }

                if(config.showEmergencyContactSection === true) {

                    if(stateKey === input.emergencyContactFirstName || stateKey === input.emergencyContactLastName) {   
                      if(registrationInfo[stateKey] === "") {
                        console.log(stateKey + " failed validation (1)");
                          validation[stateKey] = { state: validationStrings.error, helpBlock: validationStrings.error }
                      }
                    }
          
                    // if(stateKey === input.emergencyContactPhoneNumber) {           
          
                    //   console.log("Evaluating contact phone number: " + stateKey);
                    //     debugger
                    //   // emergency contact mobile phone
                    //   let countryDataEmergencyContactMobilePhoneNumber = this.ref_emergencyContactPhoneNumber.current.getCountryData();         
                    //   let emergencyContactMobilePhoneNumber = this.ref_emergencyContactPhoneNumber.current.numberInputRef.value.replace(/\D/g, "").trim()          
                    //   let emergencyContactMobilePhoneNumberWithoutDialCode = emergencyContactMobilePhoneNumber.replace(countryDataEmergencyContactMobilePhoneNumber.dialCode, "").trim(); 
          
                    //   if(stateKey === input.emergencyContactPhoneNumber && emergencyContactMobilePhoneNumberWithoutDialCode !== "") {            
                        
                    //     console.log("countryDataEmergencyContactMobilePhoneNumber.countryCode.toUpperCase(): " + countryDataEmergencyContactMobilePhoneNumber.countryCode.toUpperCase());
          
                    //     if (this._isValidPhone(this.ref_emergencyContactPhoneNumber.current.numberInputRef.value, countryDataEmergencyContactMobilePhoneNumber.countryCode.toUpperCase()))
                    //     {
                    //       console.log("Emergency number is valid. Number: " + 
                    //         this.ref_emergencyContactPhoneNumber.current.numberInputRef.value + " iso2: " + countryDataEmergencyContactMobilePhoneNumber.countryCode.toUpperCase());
                    //     }
                    //     else {
                    //       console.log("Emergency number is invalid.");
                    //       validation[stateKey] = { state: validationStrings.error, helpBlock: validationStrings.error };
                    //       toast.error("Emergency number " + this.ref_emergencyContactPhoneNumber.current.numberInputRef.value + " is not valid for country " + countryDataEmergencyContactMobilePhoneNumber.name + ".", { autoClose: 10000 });
                    //     }
                    //   }  
                      
                    //   if (emergencyContactMobilePhoneNumberWithoutDialCode === "") {
                    //     console.log(stateKey + " failed validation. Phone number must be provided.");
                    //     validation[stateKey] = { state: validationStrings.error, helpBlock: validationStrings.required };
                    //     toast.error("Blank is not a valid emergency contact phone number.", {autoClose: 10000});
                    //   }
                    // }
                    if(stateKey === input.emergencyContactPhoneNumber) {                    
                        if(registrationInfo[stateKey].length < 14 && !this._isValidPhone(registrationInfo[stateKey])){                            
                            validation[stateKey] = {                        
                                state: validationStrings.error,
                                helpBlock: validationStrings.error,
                            };
                        }
                    }

                    if(stateKey === input.emergencyContactEmail ) {                    
                      if(!this._isValidEmail(registrationInfo[stateKey])) {    
                        console.log(stateKey + " failed validation");                        
                        validation[stateKey] = { state: validationStrings.error, helpBlock: validationStrings.error };
                        toast.error((registrationInfo[stateKey] === "" ? "Blank" : registrationInfo[stateKey]) + " is not a valid e-mail address.", {autoClose: 10000});
                      }
                    }
                  }
                               
                if (!registrationInfo[stateKey]) {
                    if (stateKey === input.npi) {
                        if (!registrationInfo.attest) {
                            validation[stateKey] = {
                                state: validationStrings.error,
                                helpBlock: validationStrings.required,
                            };                            
                        }                                                            
                    }
                }

                if (stateKey === input.addressType && !registrationInfo.addressType) {
                    console.log(stateKey + " failed validation");
                    validation[input.addressType] = { state: validationStrings.error, helpBlock: validationStrings.required };
                }

                if(stateKey === input.country && !registrationInfo.country) {
                    console.log(stateKey + " failed validation");
                    validation[input.country] = { state: validationStrings.error, helpBlock: validationStrings.required };
                }
                
                if(stateKey === input.street1 && (!registrationInfo.street1 ||  registrationInfo[input.street1] === "") ) {
                    console.log(stateKey + " failed validation");
                    validation[input.street1] = { state: validationStrings.error, helpBlock: validationStrings.required };
                }
          
                if(stateKey === input.city && (!registrationInfo.city ||  registrationInfo[input.city] === "")) {          
                    console.log(stateKey + " failed validation");
                    validation[input.city] = { state: validationStrings.error, helpBlock: validationStrings.required };          
                }
          
                if(stateKey === input.state && (this.state.internationalCountriesWithStates.includes(registrationInfo.country) && registrationInfo[input.state] === "")) {
                    console.log(stateKey + " failed validation");
                    validation[input.state] = { state: validationStrings.error, helpBlock: validationStrings.required };
                }

                if(stateKey === input.zip) {
                    let country = this.state.internationalCountries.filter(obj => {
                      return obj.countryName === this.ref_contactCountry.current.value
                    })
                    let result = this._isValidPostalCode(country[0].iso2, this.ref_contactPostalCode.current.value);
                    if(result !== true) {
                      console.log(stateKey + " failed validation: " + result);
                      validation[input.zip] = { state: validationStrings.error, helpBlock: "" };              
                      toast.error("Postal code " + (this.ref_contactPostalCode.current.value === "" ? "blank" : this.ref_contactPostalCode.current.value) + " is not valid for country " + this.ref_contactCountry.current.value + ".", {autoClose: 10000});
                    }
                }
            }
        });

        this.setState({ validation });      

        return !Object.keys(validation).length;
    };

    render() {

        if (this.state.loading) {
            return <LoadingContent />;
        }
        
        let { registrationInfo, validation } = this.state;        

        return (
            <Page title="Conference Registration">
                <form>
                    <Box title="Register Now!">
                        <div className="row">
                            <div className="col-lg-6">
                                <div className={"inner-content mb-2 " + (
                                    validation[input.country] || 
                                    validation[input.county] || 
                                    validation[input.street1] || 
                                    validation[input.city] || 
                                    validation[input.zip] || 
                                    validation[input.state] 
                                    ? validationStrings.error : "")}>                                    
                                    <div className="mb-4">
                                        <div className="section-header">
                                            Contact Address (Required)
                                        </div>                                        
                                        {this.props.me.event.conferenceType  === "HealthPolicy" &&
                                        <div className="question mb-2 ">
                                            Your home address, where you are registered to vote, is required if you are attending Hill Day on the final day of conference so that AANP can schedule you with the appropriate congressional offices.
                                        </div>}
                                        {registrationInfo.preferredMailingAddress === "" && (
                                            <div className="question">
                                                Please add a preferred address below:
                                            </div>
                                        )}
                                    </div>
                                    <div className="mb-2">
                                        <label>Address Type</label>
                                        <select
                                            value={registrationInfo.addressType}
                                            name="addressType"
                                            onChange={this._handleChange}
                                            className={ validation[input.addressType] ? validationStrings.error : "" }
                                        >
                                            <option value="" />
                                            <option>Home Address</option>
                                            <option>Work Address</option>
                                        </select>
                                    </div>                                    
                                    <div className="mb-2">
                                        <label>Country</label>
                                        <select
                                            ref={this.ref_contactCountry}              
                                            value={registrationInfo.country ? registrationInfo.country : ""}
                                            name="country"
                                            autoComplete="address-country"
                                            onChange={this._handleChange}
                                            className={validation[input.country] ? validationStrings.error : ""}                        
                                            >
                                            <option value="">Please select one of the following</option>
                                            {this.state.internationalCountries.map((country, key) => (
                                                <option 
                                                key={key} 
                                                value={country.countryID}>{country.countryName}
                                                </option>
                                            ))}
                                        </select>
                                    </div>                                    
                                    {registrationInfo.addressType === "Work Address" && (
                                      <div className="mb-2">
                                        <label>Company Name (If Applicable)</label>
                                        <input
                                          type="text"
                                          name="companyName"
                                          autoComplete="organization"
                                          value={registrationInfo.companyName ? registrationInfo.companyName : ""}
                                          onChange={this._handleChange}
                                        />
                                      </div>
                                    )}
                                    
                                    <div className="row">
                                        <div className="col-md-8">
                                            <label>Street Address</label>
                                            <input
                                                type="text"
                                                name="street1"
                                                autoComplete="address-line1"
                                                 value={ registrationInfo.street1 ? registrationInfo.street1 : "" }
                                                className={ validation[input.street1] ? validationStrings.error : "" }
                                                onChange={this._handleChange}
                                            />
                                        </div>
                                        <div className="col-md-4">
                                            <label>Suite / Apt #</label>
                                            <input
                                                type="text"
                                                name="street2"
                                                autoComplete="address-line2"
                                                value={
                                                    registrationInfo.street2
                                                        ? registrationInfo.street2
                                                        : ""
                                                }
                                                onChange={this._handleChange}
                                            />
                                        </div>
                                    </div>
                                    {this.state.showInternationalRegionTerritory &&
                                        <div className="mb-2">
                                        <label>Region / Territory</label>
                                        <input
                                            type="text"
                                            name="county"
                                            autoComplete="address-region"
                                            value={ registrationInfo.county ? registrationInfo.county : "" }                        
                                            onChange={this._handleChange}
                                        />
                                        </div>
                                    }
                                    <div className="row">
                                        <div className="col-md-6">
                                            <label>City</label>
                                            <input
                                                type="text"
                                                name="city"
                                                autoComplete="address-level2"
                                                value={registrationInfo.city ? registrationInfo.city : ""}
                                                className={validation[input.city] ? validationStrings.error : ""}
                                                onChange={this._handleChange}
                                            />
                                        </div>
                                        {this.state.showState &&                    
                                          <div className="col-md-3">           
                                            <label>State</label>
                                            <select
                                              value={registrationInfo.state ? registrationInfo.state : ""}                                                    
                                              name="state"
                                              onChange={this._handleChange}
                                              autoComplete="address-level1"
                                              className={validation[input.state] ? validationStrings.error : ""}
                                            >                
                                              {this.state.internationalStates.map((state, key) => (
                                                <option 
                                                  key={key} 
                                                  value={state.stateAbbreviation}>{state.stateName}
                                                </option>
                                              ))}
                                            </select>
                                          </div>
                                        }
                                        <div className="col-md-3">
                                            <label>Postal Code</label>
                                            <input
                                                ref={this.ref_contactPostalCode}
                                                type="text"
                                                name="zip"
                                                autoComplete="postal-code"
                                                maxLength="10"
                                                value={registrationInfo.zip ? registrationInfo.zip : ""}
                                                className={validation[input.zip] ? validationStrings.error : ""}
                                                onChange={this._handleChange}
                                            />
                                        </div>
                                    </div>
                                </div>
                                <div className="inner-content mb-2">
                                    <div className="section-header">NPI Number (Required)</div>
                                    <div className={"question mb-2 " + (validation[input.npi] ? validationStrings.error : "")}>Please enter your personal NPI Number below:</div>
                                    <div className="mb-1">
                                        <input
                                            type="text"
                                            name="npi"
                                            maxLength="10"
                                            value={registrationInfo.npi ? registrationInfo.npi : ""}
                                            className={
                                                validation[input.npi] ? validationStrings.error : ""
                                            }
                                            onChange={this._handleChange}
                                        />
                                    </div>
                                    <div className="mb-2">
                                        <a
                                            href="https://npiregistry.cms.hhs.gov/"
                                            target="_blank"
                                            rel="noopener noreferrer"
                                        >
                                            Look up your NPI number.
                                        </a>
                                    </div>                                    
                                    <div className="mb-3">
                                        <input
                                            type="checkbox"
                                            id="attest"
                                            name="attest"
                                            onChange={this._handleChange}
                                        />
                                        <label htmlFor="attest">
                                            I attest I do not have an NPI Number.
                                        </label>
                                    </div>                                    
                                </div>
                                {/* <div className={"inner-content mb-2"}>
                                    <div className="section-header">Safety Acknowledgment</div>
                                    <div className="question mb-2">By registering, I agree to adhere to any AANP, Centers for Disease Control and Prevention and local guidelines or regulations related to any infectious disease, including COVID-19, in place at the time of the event.</div>                                                                                                                    
                                    <div className="divider d-lg-none" />
                                    <div className="mb-1">
                                        <input
                                            type="checkbox"
                                            id="ackCovidSafety"
                                            name="ackCovidSafety"                                                
                                            onChange={this._handleChange}                                                                                            
                                        />
                                        <label htmlFor="ackCovidSafety">I acknowledge</label>
                                    </div>
                                </div> */}
                            </div>
                            <div className="col-lg-6">
                                <div className="inner-content mb-2">
                                    <div className="section-header">Additional Information</div>
                                    <div className="question mb-2" style={{ lineHeight: "22px" }}>
                                        Is this your first time attending an AANP Health Policy Conference?
                                    </div>
                                    <div className="mb-4">
                                        <select
                                            name="isFirstConference"
                                            value={                                               
                                                registrationInfo.isFirstConference !== null
                                                    ? registrationInfo.isFirstConference
                                                    : null
                                            }
                                            onChange={this._handleChange}
                                            className={
                                                validation[input.isFirstConference]
                                                    ? validationStrings.error
                                                    : null
                                            }
                                        >
                                            <option value="">Select One</option>
                                            <option value="true">Yes</option>
                                            <option value="false">No</option>
                                        </select>
                                    </div>
                                    <div className="divider d-lg-none" />
                                    <div className="question mb-2" style={{ lineHeight: "22px" }}>
                                        Will you attend Hill Day <span>on </span>
                                        {healthPolicyInfo.hillDayDate}? If yes, you should anticipate that your congressional meetings may be scheduled up until 4:00 p.m.
                                    </div>                                    
                                    <div className="mb-4">
                                        <select
                                            name="willHillDay"
                                            value={
                                                registrationInfo.willHillDay !== null
                                                    ? registrationInfo.willHillDay
                                                    : null
                                            }
                                            onChange={this._handleChange}
                                            className={
                                                validation[input.willHillDay]
                                                    ? validationStrings.error
                                                    : null
                                            }
                                        >
                                            <option value="">Select One</option>
                                            <option value="true">Yes</option>
                                            <option value="false">No</option>
                                        </select>
                                    </div>
                                    <div className="divider d-lg-none" />                                                                        
                                    {this.state.registrationInfo.willHillDay === "true" ? (
                                        <div>
                                            <div
                                                className="question mb-2"
                                                style={{ lineHeight: "22px" }}
                                            >                                                
                                                If your travel plans require you to leave D.C. prior to 4:00 p.m., please indicate the latest time you can attend a congressional meeting. 
                                            </div>
                                            <div className="mb-3" style={{fontSize: "0.85rem"}}>Please note: it is advised to add two hours after your final meeting to return to hotel and travel to airport if flying out of DCA. Flights out of Dulles (IAD) or BWI will need additional travel time.</div>                    
                                            
                                            <div>
                                                <div className="mb-4">
                                                    <select
                                                        name="hillDayDepartureTime"
                                                        value={registrationInfo.hillDayDepartureTime ? registrationInfo.hillDayDepartureTime : ""}
                                                        onChange={this._handleChange}
                                                        className={validation[input.hillDayDepartureTime] ? validationStrings.error : ""}
                                                    >
                                                        <option value="">Not Applicable</option>
                                                        <option value="10:30 a.m.">10:30 a.m.</option>
                                                        <option value="11:00 a.m.">11:00 a.m.</option>
                                                        <option value="11:30 a.m.">11:30 a.m.</option>
                                                        <option value="12:00 p.m.">12:00 p.m.</option>
                                                        <option value="12:30 p.m.">12:30 p.m.</option>
                                                        <option value="1:00 p.m.">1:00 p.m.</option>
                                                        <option value="1:30 p.m.">1:30 p.m.</option>
                                                        <option value="2:00 p.m.">2:00 p.m.</option>
                                                        <option value="2:30 p.m.">2:30 p.m.</option>
                                                        <option value="3:00 p.m.">3:00 p.m.</option>
                                                        <option value="3:30 p.m.">3:30 p.m.</option>
                                                        <option value="4:00 p.m.">4:00 p.m.</option>                                                            
                                                    </select>
                                                </div>
                                            </div>                                            
                                            <div
                                                className="question mb-2"
                                                style={{ lineHeight: "22px" }}
                                            >
                                                Provide a cell phone number that we can use to reach you
                                                on Hill Day should any last minute changes occur.
                                            </div>
                                            <div className="mb-3">
                                                <input
                                                    type="text"
                                                    name="cellPhone"
                                                    value={
                                                        registrationInfo.cellPhone
                                                            ? registrationInfo.cellPhone
                                                            : ""
                                                    }
                                                    onChange={this._handleChange}
                                                    maxLength="15"
                                                    className={
                                                        validation[input.cellPhone]
                                                            ? validationStrings.error
                                                            : ""
                                                    }
                                                />                                                
                                            </div>
                                            <div className="mb-3" style={{ display: "flex", gap: "0.5rem" }}>
                                                <input
                                                    type="checkbox"
                                                    id="noPhoneConsent"
                                                    name="noPhoneConsent"
                                                    onChange={this._handleChange}
                                                />
                                                <label htmlFor="noPhoneConsent">
                                                    Some congressional offices require constituent cell phone numbers for the meeting to be confirmed. 
                                                    Please click here if you DO NOT consent to AANP providing your cell phone number to the congressional
                                                     office upon request.
                                                </label>
                                            </div> 
                                        </div>
                                    ) : null}
                                </div>                                      
                                
                                {config.showEmergencyContactSection &&
                                <div className={"inner-content mb-2"}>                          
                                    <div className="section-header">
                                        Emergency Contact
                                    </div>
                                    <div className="question mb-2 ">
                                        AANP is authorized to use and may utilize at their discretion my emergency contact information in the event of a medical emergency.
                                    </div>                    
                                    <div className="row mb-2">
                                        <div className="col-md-6">
                                            <label>First Name</label>
                                            <input
                                                type="text"
                                                name="emergencyContactFirstName"
                                                maxlength="50"
                                                required
                                                value={registrationInfo.emergencyContactFirstName ? registrationInfo.emergencyContactFirstName : "" }
                                                className={validation[input.emergencyContactFirstName] ? validationStrings.error : ""}                                                                                                                                
                                                onChange={this._handleChange}
                                            />
                                        </div>
                                        <div className="col-md-6">
                                            <label>Last Name</label>
                                            <input
                                                type="text"
                                                name="emergencyContactLastName"
                                                maxlength="50"
                                                required
                                                value={registrationInfo.emergencyContactLastName ? registrationInfo.emergencyContactLastName : ""}
                                                className={validation[input.emergencyContactLastName] ? validationStrings.error : ""}  
                                                onChange={this._handleChange}
                                            />                                            
                                        </div>
                                    </div>
                                    <div className="row mb-2">
                                        <div className="col">
                                            <label>Email</label>
                                            <input
                                                type="text"
                                                name="emergencyContactEmail"
                                                maxlength="100"                                                                                                                                        
                                                value={registrationInfo.emergencyContactEmail ? registrationInfo.emergencyContactEmail : ""}
                                                className={validation[input.emergencyContactEmail] ? strings.error : ""}
                                                onChange={this._handleChange}
                                            />
                                        </div>
                                    </div>                     
                                    <div className="row mb-2">
                                        <div className="col-md-6">
                                            <label>Relationship (Optional)</label>
                                                <input
                                                    type="text"
                                                    name="emergencyContactRelationship"
                                                    maxlength="50"
                                                    value={registrationInfo.emergencyContactRelationship ? registrationInfo.emergencyContactRelationship : ""}                                                       
                                                    onChange={this._handleChange}
                                                />
                                        </div>
                                        <div className="col-md-6">
                                            <label>Cell Phone Number</label>
                                            <input
                                                    type="text"
                                                    name="emergencyContactPhoneNumber"
                                                    maxlength="14"
                                                    minLength="14"
                                                    required
                                                    // className={validation[input.emergencyContactPhoneNumber] ? strings.error : ""}
                                                    value={registrationInfo.emergencyContactPhoneNumber ? registrationInfo.emergencyContactPhoneNumber : ""}
                                                    className={validation[input.emergencyContactPhoneNumber] ? validationStrings.error : ""} 
                                                    onChange={this._handleChange}
                                            />
                                        </div>
                                    </div>                                                   
                                </div>  
                                }            
                            </div>
                        </div>                        
                    </Box>
                    <Box title="Next Steps">
                        <div className="row checkout">
                            {/* TOS */}
                            <div className="col-lg">
                                <div className="inner-content mb-2">
                                    <div className="tos-box p-4">
                                        By continuing the registration process, I agree to abide by the AANP Conference{" "}
                                        <a style={{ fontWeight: "bold" }}
                                            href={strings.conferenceTermsOfService}
                                            target="_blank"
                                            rel="noopener noreferrer"
                                        >
                                            Terms of Service and Release of Liability.
                                        </a>{" "}
                                        I additionally agree to abide by AANP’s{" "}
                                        <a style={{ fontWeight: "bold" }}
                                            href={strings.aanpTermsOfUse}
                                            target="_blank"
                                            rel="noopener noreferrer"
                                        >
                                            Terms of Use
                                        </a>{" "}
                                        and{" "}
                                        <a style={{ fontWeight: "bold" }}
                                            href={strings.aanpPrivacyPolicy}
                                            target="_blank"
                                            rel="noopener noreferrer"
                                        >
                                            Privacy Policy
                                        </a>
                                    </div>

                                    {/* Button */}
                                    <div className="row mt-3">
                                        <div className="col-10 col-lg-5 col-centered">
                                            <LoadingButton
                                                text="Agree and Checkout"
                                                loadingText="Saving..."
                                                isLoading={this.state.isLoadingQuickCheckout}
                                                onClick={this._saveRegistrationInfo}
                                                value="checkout"
                                            />
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </Box>
                </form>
            </Page>
        );
    }
}

const mapStateToProps = (state, ownProps) => {
    return {
        me: state.account.me,
        joinRenewMembershipType: state.membership.joinRenewMembershipType,
        registrationMembershipType: state.membership.registrationMembershipType,
    };
};

const mapDispatchToProps = {
    ...membershipActions,
    ...registrationActions,
    ...accountActions,
};

export default withRouter(
    connect(
        mapStateToProps,
        mapDispatchToProps
    )(HealthPolicyQuestions)
);